import {RXDB_CMC_PROTOCOL_SCHEMA} from './rxdb-cmc-protocol.schema';
import {QuoteMigrations, RXDB_QUOTE_SCHEMA} from './rxdb-quote.schema';
import {RXDB_OPPORTUNITY_SCHEMA} from './rxdb-opportunities.schema';
import {RXDB_EQUOTE_OPPORTUNITY_SCHEMA} from "./rxdb-equote-opportunities.schema";

export const SCHEMA_BY_NAME = {
    'cmcprotocols': {schema: RXDB_CMC_PROTOCOL_SCHEMA, live: true, pull: true},
    'opportunities': {schema: RXDB_OPPORTUNITY_SCHEMA, live: true, pullHttp: true},
    'equote_opportunities': {schema: RXDB_EQUOTE_OPPORTUNITY_SCHEMA, live: true, pullHttp: true},
    'quotes': {schema: RXDB_QUOTE_SCHEMA, push: true, pullHttp: true, migrationStrategies: QuoteMigrations},
};

